import React, { useContext } from 'react';
import { Button } from '$partials/ui';
import { ArrowRightIcon } from '$partials/icon';
import { formatLinkBlockToUrl } from '$utilities/format';
import { ModalContext } from '$contexts/modal.jsx';
import { BookValuationModal } from '$partials/modals';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').HeaderLinks}
 */
const HeaderLinks = ({
    items,
    hubspot = {},
    ...rest
}) => {
    const { handleModal } = useContext(ModalContext);

    return (
        <div className='col-12 flex flex-wrap'>
            {items.map((item, i) => {
                const borderClass = i === 0 ? ' border-right' : i === 1 ? ' border-right border-left' : ' border-left';
                if(item.__typename === 'HeaderLinksLink') {
                    const link = formatLinkBlockToUrl(item.link);
                    return (
                        <div
                            className='col-12 sm-col-4'
                            key={i}>
                            <Button
                                as='a'
                                className = {`bg-white type-style-5 link-reset items-center border-grey${borderClass}`}
                                href={link}
                                look='fill'
                                renderIcon={<ArrowRightIcon/>}
                                target={item.link?.new_window || item.link?.linkTo === 'file' ? '_blank' : ''}>
                                {item.label}
                            </Button>
                        </div>
                    );
                } else {
                    return (
                        <div
                            className='col-12 sm-col-4'
                            key={i}>
                            <Button
                                as='a'
                                className = {`bg-white type-style-5 link-reset items-center border-grey${borderClass}`}
                                look='fill'
                                onClick={() => { handleModal(
                                    <BookValuationModal
                                        context={item.formContext}
                                        hubspot={hubspot}
                                        {...rest} />); }}
                                renderIcon={<ArrowRightIcon/>}>
                                {item.label}
                            </Button>
                        </div>
                    );
                }
            })}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HeaderLinks;
